import styled from "styled-components";

import { TAB_BAR } from "../../constants/tabBar";
import { fontSizes } from "../../shared/styles/typography";

export const Body = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 32px;
`;

export const Card = styled.section`
  background: #fff;
  border-radius: 16px;
  padding: 20px;
  border: 1px solid #e8eaf0;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
`;

export const CardTitle = styled.h2`
  font-size: ${fontSizes.xl}px;
  font-weight: var(--font-weight-bold);
  color: var(--color-text-title);
  margin: 0 0 12px;
`;

export const Text = styled.p`
  font-size: ${fontSizes.base}px;
  line-height: 1.55;
  color: var(--color-text-complement);
  margin: 0 0 12px;

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const LogoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 16px;

  img {
    width: 64px;
    height: 64px;
    border-radius: 14px;
    object-fit: contain;
  }
`;

export const PrimaryLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  padding: 10px 14px;
  border-radius: 12px;
  font-size: ${fontSizes.base}px;
  font-weight: var(--font-weight-semibold);
  color: ${TAB_BAR.primary};
  background: ${TAB_BAR.navbarBg};
  text-decoration: none;

  &:hover {
    opacity: 0.92;
  }
`;

export const InpiRow = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
  font-size: ${fontSizes.sm}px;
  color: var(--color-text-complement);
  text-decoration: none;

  &:hover {
    color: ${TAB_BAR.primary};
  }
`;

export const InesBadge = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 12px;
  background: linear-gradient(135deg, #1e3a5f, #2563eb);
  color: #fff;
  font-size: ${fontSizes.xs}px;
  font-weight: var(--font-weight-bold);
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 0.02em;
  flex-shrink: 0;
`;
